import {Box} from '@mui/material';
import {useState} from 'react';
import useLoadAds from '@jobseeker/common-core/hooks/useLoadAds';

import {ButtonV2} from '@jobseeker/lotus/elements';
import {Image} from '@jobseeker/lotus/components/Image';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import {useSelector} from 'react-redux';
import {EPOCH} from '@constants';

import type {AdsElementType, AppState} from '@jobseeker/common-core/types';
import dayjs from 'dayjs';
import {formQueryParams} from '@utils';
import {isCSR} from '@jobseeker/lotus/utils';

const CompetitionBanner = () => {
  const {
    timelines: {
      ads,
      registration: {endDate},
      round2: {resultDeclarationDate},
      config: {competitionName},
    },
  } = useSelector((state: AppState) => state.competition);

  const slotId = ads?.competitionBanner?.slotId ?? '';

  const [bannerInfo, setBannerInfo] = useState(Array<AdsElementType>);

  useLoadAds(slotId, setBannerInfo, {}, false);
  const isAboveMobile = useIsLargeDevice('sm');
  const page = useSelector((state: AppState) => state.app.page);
  const currentDate = dayjs();
  const registrationEnded = dayjs(endDate) < currentDate;
  const resultsAnnounced = dayjs(resultDeclarationDate) < currentDate;
  const {competitionIdentity, testSlug} = useSelector(
    (state: AppState) => state.user?.profile
  );

  const registeredForCompetition = competitionIdentity && testSlug;

  let queryParams = '';
  if (isCSR()) {
    queryParams = formQueryParams('');
  }

  return (
    <>
      <Box
        id="competition-banner"
        sx={{
          width: '100%',
          height: {xs: '450px', md: '530px'},
          background: `url(${
            isAboveMobile ? bannerInfo[0]?.companyLogo : bannerInfo[0]?.imageUrl
          }) no-repeat`,
          backgroundColor: '#fff',
          display: 'flex',
          justifyContent: 'center',
          position: 'sticky',
          borderBottomLeftRadius: 36,
          borderBottomRightRadius: 36,
          backgroundSize: {xs: '100% 100%', md: '100% 100%', sm: '100% 100%'},
        }}
      ></Box>
      {page === EPOCH && !registeredForCompetition && (
        <Box
          sx={{
            textAlign: 'center',
            position: 'relative',
            bottom: {xs: 140, md: 150, sm: 180},
          }}
        >
          <ButtonV2
            type="submit"
            sx={{
              width: {
                xxs: '70%',
                sm: 220,
                md: 220,
              },
              height: {xs: '60px', md: '70px'},
              padding: 3,
              borderRadius: 9,
              background: registrationEnded
                ? resultsAnnounced
                  ? '#49966E'
                  : '#ed2048'
                : '#fff',
              ':hover': {
                backgroundColor: registrationEnded
                  ? resultsAnnounced
                    ? '#33694D'
                    : '#ed2048'
                  : '#f0f0f0',
              },
              color: registrationEnded ? '#fff' : 'primary.main',
              mt: {xxs: 2, md: 1},
            }}
            href={
              registrationEnded
                ? resultsAnnounced
                  ? `/${competitionName}/winners`
                  : 'javascript:void(0);'
                : `/${competitionName}/register${
                    queryParams ? `?${queryParams}` : ''
                  }`
            }
            target="_self"
            variant="contained"
            size="large"
          >
            {registrationEnded
              ? resultsAnnounced
                ? 'Results Announced'
                : 'Registration is closed'
              : 'Register Now'}
            {!registrationEnded && (
              <Image
                src={
                  'https://static.iimjobs.com/epoch/static/assets/greenArrow.svg'
                }
                alt={'Arrow'}
                width={18}
                height={22}
                loading="eager"
                style={{
                  margin: '5px 10px',
                  float: 'right',
                }}
              />
            )}
          </ButtonV2>
        </Box>
      )}
    </>
  );
};

export default CompetitionBanner;
